import {Button, Dropdown, DropdownItem} from 'platform/components';
import {Icon} from 'platform/foundation';

import {TestIdProps, suffixTestId} from 'shared/web';

interface MemberOption {
  value: string;
  label: string;
}

interface RecordAuditMemberEditDropdownProps extends TestIdProps {
  options: MemberOption[];
  selectedValue: string;
  isLoading?: boolean;
  onSelect: (value: string) => void;
}

/** Inline edit dropdown used to switch a team member (e.g. the auditor); mirrors the branch dropdown. */
export function RecordAuditMemberEditDropdown(props: RecordAuditMemberEditDropdownProps) {
  return (
    <Dropdown
      placement="bottom-end"
      closeOnSelect
      dropdownControl={
        <Button
          variant="ghostLink"
          size="small"
          leftIcon="image/edit"
          isLoading={props.isLoading}
          data-testid={suffixTestId('edit', props)}
        />
      }
    >
      {props.options.map((option) => (
        <DropdownItem
          key={option.value}
          label={option.label}
          onClick={() => props.onSelect(option.value)}
          suffix={
            option.value === props.selectedValue ? <Icon value="action/done" size={4} /> : undefined
          }
          data-testid={suffixTestId(`option-${option.value}`, props)}
        />
      ))}
    </Dropdown>
  );
}
